import type { DataQualitySuggestion, ResearchSuggestionSuggestion } from '@fs/zion-tree-types'
import type { ResearchHelpData } from './useResearchHelpData'

export function getDataProblemSuggestions(
  researchHelp: Partial<ResearchHelpData>,
  type: 'dismissed' | 'nonDismissed' = 'nonDismissed'
): DataQualitySuggestion[] {
  const dataProblemsDismissed: DataQualitySuggestion[] = [
    ...(researchHelp.childDataProblemsDismissed ?? []),
    ...(researchHelp.couplesDismissed?.dataQualityList ?? []),
    ...(researchHelp.duplicateChildDataProblemsDismissed ?? []),
    ...(researchHelp.focusPersonDismissed?.dataQualityList ?? []),
    ...(researchHelp.duplicatePersonDataProblemsDismissed ?? []),
  ]

  const dataProblems: DataQualitySuggestion[] = [
    ...(researchHelp.childDataProblems ?? []),
    ...(researchHelp.couples?.dataQualityList ?? []),
    ...(researchHelp.duplicatePersonDataProblems ?? []),
    ...(researchHelp.duplicateChildDataProblems ?? []),
    ...(researchHelp.duplicateSpouseDataProblems ?? []),
    ...(researchHelp.focusPerson?.dataQualityList ?? []),
  ]
  if (type === 'dismissed') return dataProblemsDismissed
  return dataProblems
}

export function getResearchSuggestionSuggestions(
  researchHelp: Partial<ResearchHelpData>,
  type: 'dismissed' | 'nonDismissed' = 'nonDismissed'
): ResearchSuggestionSuggestion[] {
  const researchSuggestionsDismissed: ResearchSuggestionSuggestion[] = [
    ...(researchHelp.couplesDismissed?.researchSuggestionList ?? []),
    ...(researchHelp.focusPersonDismissed?.researchSuggestionList ?? []),
  ]
  const researchSuggestions: ResearchSuggestionSuggestion[] = [
    ...(researchHelp.couples?.researchSuggestionList ?? []),
    ...(researchHelp.focusPerson?.researchSuggestionList ?? []),
  ]

  if (type === 'dismissed') return researchSuggestionsDismissed
  return researchSuggestions
}
